module.exports = __webpack_public_path__ + "static/media/favicon-196.859e8071.png";